export enum TournamentType {
  LOCAL,
  PROVIDER,
}

export enum TournamentStatus {
  INITIAL,
  ANNOUNCE,
  ACTIVE,
  FINISHED,
}

export type Player = {
  name: string;
};

// export type ImageRecord = {
//     locale: string;
//     mainPreview: string;
//     main: string;
//     mobile: string;
//     mobilePreview: string;
// };

export type ImageRecord = {
  main: string;
  mobile: string;
};

export type TournamentListResponseType = {
  statusCode: number;
  tournaments: TournamentDataType[];
};
export type TournamentResponseType = {
  statusCode: number;
  tournament: TournamentDataType;
};

export type TournamentPrizePoolType = {
  place: number;
  prize: number;
};

export type TournamentDataType = {
  id: number; // id турнира
  currencyId: number; // id валюты
  name: string; // название
  header: string; // название
  provider: string;
  geo: string[];
  type: string; // тип турнира (внешний/внутренний)
  gameIdList: string[]; // список участвующих игр Game
  prizePool: TournamentPrizePoolType[] | null; // список призовых мест
  image: ImageRecord[]; // картинки для турнира TournamentLocaleImage
  totalPrizePool: number;
  startDate: string; // дата начала турнира
  endDate: string; // дата окончания турнира
  rules: string; // правила турнира
  minBet: number;
  description: string;
};

// export type TournamentCardType = {
//   id: number; // id турнира
//   currencyId: number; // id валюты
//   name: string; // название
//   type: string; // тип турнира (внешний/внутренний)
//   gameIdList: string[]; // список участвующих игр Game
//   prizePool: TournamentPrizePoolType[]; // список призовых мест
//   status: TournamentStatus; // статус создан/активен/результаты/закрыт
//   image: ImageRecord[]; // картинки для турнира TournamentLocaleImage
//   startDate: string; // дата начала турнира
//   endDate: string; // дата окончания турнира
//   rules: string; // правила турнира
//   totalPrizePool: number;
// };
export type TournamentCardType = TournamentDataType & {
  status: TournamentStatus; // статус создан/активен/результаты/закрыт
  rules: string; // правила турнира
};
